/* eslint-disable indent */
/* eslint-disable complexity */
import { getAriaOrDataProps } from '../getProps/index.js';

/**
 * Returns the props for a given dataTestId.
 * props are going to be filtered so only aria related and data-* props are going to be returned.
 * @param {Record<string, string> | (() => Record<string, string>)} userProps - The props passed by the user.
 * @returns The props for the given dataTestId.
 * @example
 * const userProps = {
 *  'ds-controlled-date-time-picker-month-input': {
 *    'aria-label': 'month-input-aria-label',
 *    'data-test': 'month-input-data-test',
 *    somethingElse: 'this will not be returned',
 *  },
 *  'ds-controlled-date-time-picker-day-input': {
 *   'aria-label': 'day-aria-label',
 *   'data-test': 'day-data-test',
 *  },
 * };
 * const dataTestIdProps = getDataTestIdProps(userProps['ds-controlled-date-time-picker-day-input']);
 * // dataTestIdProps = {
 * //   'aria-label': 'day-aria-label',
 * //   'data-test': 'day-data-test',
 * // }
 * @example
 * const userProps = {
 *   'ds-controlled-date-time-picker-month-input': {
 *     'aria-label': 'month-input-aria-label',
 *     'data-test': 'month-input-data-test',
 *   },
 *   'ds-controlled-date-time-picker-day-input': (props) => ({ // notice that this is a function that returns an object
 *     'aria-label': 'day-aria-label',
 *     'data-test': 'day-data-test',
 *     somethingElse: 'this will not be returned',
 *   }),
 * };
 * const dataTestIdProps = getDataTestIdProps(userProps['ds-controlled-date-time-picker-day-input']);
 * // dataTestIdProps = {
 * //   'aria-label': 'day-aria-label',
 * //   'data-test': 'day-data-test',
 * // }
 * @fires getAriaOrDataProps
 */
const getPropsPerDatatestid = (userProps: AriaAndDataPropsOrPropsGetter | undefined) => {
  if (
    userProps === undefined ||
    userProps === null ||
    (typeof userProps !== 'object' && typeof userProps !== 'function')
  )
    return {};

  if (typeof userProps === 'function') {
    const values = getAriaOrDataProps(userProps());
    return values;
  }
  return getAriaOrDataProps(userProps);
};

export { getPropsPerDatatestid };
